// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || '';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAP_API = process.env.REACT_APP_MAPBOX_API;

// export const SERVER_API = 'https://tourism.denoo.my/BESarawakApi/api/BESarawakApi/';

export const SERVER_API = 'https://tourism.denoo.my/BESarawakDevAPI/api/BESarawakApi/';

// MEITD CMS API (JWT) — same-origin '/api' in production (IIS reverse proxy),
// override for local dev with REACT_APP_CMS_API=http://localhost:5001/api
export const CMS_API = process.env.REACT_APP_CMS_API || '/api';

// ROOT PATH AFTER LOGIN SUCCESSFUL
// Every role lands on Talent Intelligence — the legacy event-impact and event
// organizer dashboards are retired.
export const PATH_AFTER_LOGIN_ADMIN = PATH_DASHBOARD.general.talentIntelligence;
export const PATH_AFTER_LOGIN_ORGANIZER = PATH_DASHBOARD.general.talentIntelligence;

// Landing path for a user, by role id (1 admin, 2 organizer, 3 viewer, 4 superadmin)
export const pathAfterLogin = () => PATH_DASHBOARD.general.talentIntelligence;

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
